import { LoginAnalyticsGaService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthMethods } from '@user/const';
import { LoginFormComponentService } from '../../login-form-component.service';

@Component({
  selector: 'sd-login-by-password-form',
  templateUrl: './login-by-password-form.component.html',
  styleUrls: ['./login-by-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginByPasswordFormComponent implements OnInit {
  form = this.fb.group({
    phone: this.loginFormComponentService.getPhoneControl(),
    password: ['', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private loginFormComponentService: LoginFormComponentService,
    private loginAnalyticsService: LoginAnalyticsGaService,
  ) {}

  ngOnInit(): void {
    this.resetFormValidity();
  }

  toggleAuthMethod(): void {
    this.loginFormComponentService.setCurrentAuthMethod(AuthMethods.ByCode);

    this.loginAnalyticsService.sendGa('click_loginSMS_btn');
  }

  login(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();

      return;
    }

    this.loginFormComponentService.login(
      this.form.controls.phone.value,
      this.form.controls.password.value as string,
      false,
    );
  }

  resetFormValidity(): void {
    this.form.markAsPristine();
    this.form.markAsUntouched();
    this.form.updateValueAndValidity();
  }
}
